import { JWPlayer, VideoPlayerType } from '../types/video';
import { PlayerFeature } from './types';

// Remove excess content from he player container to improve SEO. Make them available after user interaction.
// Gated to apply only to mobile and auto-play videos
export default function setup(player: JWPlayer, { autostart }: VideoPlayerType, isMobile: boolean): PlayerFeature {
  if (!isMobile || !autostart) {
    return {
      preConfig: () => ({}),
      onReady: () => {},
    };
  }

  // look at window height to determine if device is likely a bot
  // https://www.seroundtable.com/googlebot-9000px-high-viewport-24727.html
  const isBot = window?.innerHeight > 4000;

  const preConfig = () => {
    // https://docs.jwplayer.com/players/reference/setup-options
    return {
      autostart: isBot ? false : autostart,
      displaydescription: !isBot,
      displaytitle: !isBot,
      controls: false, // initially hide controls for autoplay on mobile
      showUIWhen: 'onContent', // video will not be loaded before visible (but container is created)
      // generateSEOMetadata: false,
    };
  };

  const onReady = () => {
    const enableControls = (e: 'float' | 'click') => {
      if (!player?.getControls()) {
        player?.setControls(true); // enable controls on first interaction
      }
    };
    player.on('click', enableControls);
    player.on('float', enableControls);
  };

  return {
    preConfig,
    onReady,
  };
}
